const PALS = {
  aurora: ["#4c7dff", "#8b5cf6", "#22d3ee", "#0f172a", "#f8fafc"],
  forest: ["#14532d", "#166534", "#4d7c0f", "#a3e635", "#052e16"],
  space: ["#020617", "#1e1b4b", "#4c1d95", "#818cf8", "#22d3ee"],
  medieval: ["#3f2a14", "#7f1d1d", "#b45309", "#eab308", "#faf6ee"],
  ocean: ["#082f49", "#0e7490", "#22d3ee", "#67e8f9", "#ecfeff"],
  desert: ["#78350f", "#c2410c", "#f59e0b", "#fde68a", "#fff7ed"],
  volcano: ["#1c0a0a", "#7f1d1d", "#ea580c", "#fbbf24", "#fff1f2"],
  tundra: ["#0f172a", "#164e63", "#67e8f9", "#a5b4fc", "#e0f2fe"],
  neon: ["#4a044e", "#db2777", "#f472b6", "#22d3ee", "#fdf4ff"],
  sakura: ["#9f1239", "#fb7185", "#fecdd3", "#fff1f2", "#1f0a14"],
  swamp: ["#1a2e05", "#3f6212", "#84cc16", "#f7fee7", "#0f1a05"],
  arcade: ["#14532d", "#eab308", "#22c55e", "#f97316", "#fefce8"],
  scroll: ["#44403c", "#b45309", "#d6d3d1", "#fef3c7", "#1c1917"],
  abyss: ["#020617", "#134e4a", "#2dd4bf", "#6366f1", "#f0fdfa"],
  steam: ["#1c1917", "#78350f", "#d97706", "#fbbf24", "#fafaf9"],
  farm: ["#14532d", "#65a30d", "#86efac", "#38bdf8", "#f0fdf4"],
  void: ["#020617", "#0ea5e9", "#22d3ee", "#6366f1", "#e8f4f8"],
  ember: ["#1a0b08", "#f97316", "#ef4444", "#fbbf24", "#fff4eb"],
  moss: ["#052e16", "#10b981", "#34d399", "#0d9488", "#ecfdf5"],
  orchid: ["#1a0b2e", "#a855f7", "#c084fc", "#ec4899", "#faf5ff"],
  ink: ["#020617", "#334155", "#64748b", "#e2e8f0", "#f8fafc"],
  dungeon: ["#020617", "#1e293b", "#334155", "#f59e0b", "#22d3ee"],
  clouds: ["#38bdf8", "#7dd3fc", "#e0f2fe", "#65a30d", "#f0fdf4"],
  cave: ["#020617", "#134e4a", "#2dd4bf", "#042f2e", "#f0fdfa"],
};

function palOf(id) {
  return PALS[id] || PALS.aurora;
}

const W = 160;
const H = 90;

function hexLerp(a, b, t) {
  const parse = (h) => {
    const s = String(h || "#000000").replace("#", "").padEnd(6, "0").slice(0, 6);
    return [parseInt(s.slice(0, 2), 16) || 0, parseInt(s.slice(2, 4), 16) || 0, parseInt(s.slice(4, 6), 16) || 0];
  };
  const A = parse(a);
  const B = parse(b);
  const ch = (i) => Math.round(A[i] + (B[i] - A[i]) * t).toString(16).padStart(2, "0");
  return `#${ch(0)}${ch(1)}${ch(2)}`;
}

function rnd(seed) {
  let s = seed;
  return () => {
    s = (s * 16807 + 11) % 2147483647;
    return s / 2147483647;
  };
}

function seedFrom(id) {
  let n = 1;
  for (let i = 0; i < (id || "").length; i++) n = (n * 31 + id.charCodeAt(i)) % 2147483647;
  return n || 42;
}

function canvas() {
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const ctx = c.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  return { c, ctx };
}

function sky(ctx, c0, c1) {
  for (let y = 0; y < H; y++) {
    ctx.fillStyle = hexLerp(c0, c1, y / (H - 1));
    ctx.fillRect(0, y, W, 1);
  }
}

function stars(ctx, n, color, rand) {
  ctx.fillStyle = color;
  for (let i = 0; i < n; i++) {
    const x = Math.floor(rand() * W);
    const y = Math.floor(rand() * (H * 0.62));
    ctx.fillRect(x, y, rand() > 0.8 ? 2 : 1, 1);
  }
}

function hills(ctx, y0, amp, color, rand, step = 3) {
  ctx.fillStyle = color;
  for (let x = 0; x < W; x++) {
    const h = Math.floor(Math.sin(x / step + rand() * 0.2) * amp + amp);
    ctx.fillRect(x, y0 - h, 1, H - (y0 - h));
  }
}

function rect(ctx, color, x, y, w, h) {
  ctx.fillStyle = color;
  ctx.fillRect(x, y, w, h);
}

function tree(ctx, x, y, trunk, leaf) {
  rect(ctx, trunk, x, y, 3, 14);
  rect(ctx, leaf, x - 5, y - 8, 13, 10);
  rect(ctx, leaf, x - 3, y - 12, 9, 6);
}

function mountain(ctx, x, y, w, h, color, snow) {
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x + w / 2, y - h);
  ctx.lineTo(x + w, y);
  ctx.closePath();
  ctx.fill();
  if (snow) {
    ctx.fillStyle = snow;
    ctx.beginPath();
    ctx.moveTo(x + w * 0.35, y - h * 0.55);
    ctx.lineTo(x + w / 2, y - h);
    ctx.lineTo(x + w * 0.65, y - h * 0.55);
    ctx.closePath();
    ctx.fill();
  }
}

function paintScene(id) {
  const { c, ctx } = canvas();
  const pal = palOf(id);
  const [c0, c1, c2, c3, c4] = pal;
  const rand = rnd(seedFrom(id));

  const scenes = {
    forest() {
      sky(ctx, c0, c4);
      stars(ctx, 18, c4, rand);
      rect(ctx, c3, 118, 18, 10, 10);
      hills(ctx, 62, 10, c0, rand, 7);
      for (let i = 0; i < 9; i++) tree(ctx, 8 + i * 18, 48 + (i % 3) * 4, c0, i % 2 ? c1 : c2);
      rect(ctx, c1, 0, 78, W, 12);
    },
    space() {
      sky(ctx, c0, c1);
      stars(ctx, 70, c4, rand);
      rect(ctx, c2, 108, 22, 22, 22);
      rect(ctx, c3, 112, 26, 14, 14);
      rect(ctx, c1, 0, 70, W, 20);
      for (let i = 0; i < 6; i++) rect(ctx, c2, 10 + i * 28, 64, 16, 8);
    },
    ocean() {
      sky(ctx, c4, c1);
      rect(ctx, c3, 118, 16, 12, 12);
      for (let y = 42; y < H; y++) {
        ctx.fillStyle = hexLerp(c2, c0, (y - 42) / 48);
        ctx.fillRect(0, y, W, 1);
      }
      ctx.fillStyle = c4;
      for (let x = 0; x < W; x += 6) ctx.fillRect(x, 44 + Math.floor(Math.sin(x / 8) * 2), 4, 1);
      rect(ctx, c1, 24, 50, 28, 8);
      rect(ctx, c0, 32, 44, 12, 8);
    },
    desert() {
      sky(ctx, c1, c3);
      rect(ctx, c4, 22, 16, 16, 16);
      hills(ctx, 58, 14, c1, rand, 11);
      hills(ctx, 72, 8, c2, rand, 8);
      rect(ctx, c0, 0, 82, W, 8);
    },
    volcano() {
      sky(ctx, c0, c1);
      mountain(ctx, 20, 78, 70, 50, c1, c3);
      mountain(ctx, 70, 80, 90, 42, c0, c2);
      rect(ctx, c2, 0, 78, W, 12);
      for (let i = 0; i < 8; i++) rect(ctx, c3, 40 + i * 4, 30 + i, 2, 8);
    },
    tundra() {
      sky(ctx, c0, c2);
      for (let x = 0; x < W; x++) {
        ctx.fillStyle = hexLerp(c3, c2, Math.abs(Math.sin(x / 20)));
        ctx.fillRect(x, 10, 1, 16);
      }
      mountain(ctx, 10, 78, 50, 36, c1, c4);
      mountain(ctx, 50, 80, 70, 44, c0, c4);
      rect(ctx, c4, 0, 78, W, 12);
    },
    neon() {
      sky(ctx, c0, c1);
      stars(ctx, 20, c3, rand);
      for (let i = 0; i < 12; i++) {
        const bh = 18 + Math.floor(rand() * 40);
        rect(ctx, i % 2 ? c1 : c0, 4 + i * 13, H - bh, 11, bh);
        rect(ctx, rand() > 0.5 ? c2 : c3, 7 + i * 13, H - bh + 4, 2, 2);
        rect(ctx, c3, 10 + i * 13, H - bh + 10, 2, 2);
      }
      rect(ctx, c2, 0, H - 6, W, 6);
    },
    sakura() {
      sky(ctx, c1, c4);
      rect(ctx, c4, 20, 14, 14, 14);
      tree(ctx, 30, 48, c0, c2);
      tree(ctx, 70, 52, c0, c1);
      tree(ctx, 118, 46, c0, c2);
      for (let i = 0; i < 22; i++) rect(ctx, c2, Math.floor(rand() * W), 20 + Math.floor(rand() * 50), 1, 1);
      rect(ctx, c0, 0, 80, W, 10);
    },
    swamp() {
      sky(ctx, c0, c1);
      hills(ctx, 60, 6, c1, rand, 9);
      for (let i = 0; i < 6; i++) tree(ctx, 12 + i * 26, 50, c0, c2);
      rect(ctx, c1, 0, 72, W, 18);
      ctx.fillStyle = c3;
      for (let x = 0; x < W; x += 8) ctx.fillRect(x, 74, 3, 1);
    },
    arcade() {
      sky(ctx, c0, c1);
      for (let y = 0; y < H; y += 2) {
        ctx.fillStyle = "rgba(0,0,0,0.18)";
        ctx.fillRect(0, y, W, 1);
      }
      rect(ctx, c2, 20, 30, 40, 28);
      rect(ctx, c3, 90, 24, 36, 34);
      rect(ctx, c1, 0, 70, W, 20);
    },
    medieval() {
      sky(ctx, c0, c4);
      mountain(ctx, 0, 70, 80, 30, c0, null);
      rect(ctx, c1, 70, 38, 50, 42);
      rect(ctx, c2, 78, 22, 12, 18);
      rect(ctx, c2, 100, 18, 12, 22);
      rect(ctx, c0, 86, 48, 8, 12);
      rect(ctx, c3, 0, 78, W, 12);
    },
    abyss() {
      sky(ctx, c0, c1);
      stars(ctx, 28, c2, rand);
      for (let i = 0; i < 10; i++) rect(ctx, c2, Math.floor(rand() * W), 40 + Math.floor(rand() * 40), 1, 1 + Math.floor(rand() * 4));
      rect(ctx, c1, 0, 78, W, 12);
      mountain(ctx, 30, 86, 40, 28, c0, c3);
    },
    steam() {
      sky(ctx, c0, c1);
      rect(ctx, c2, 20, 50, 50, 28);
      rect(ctx, c3, 30, 40, 30, 12);
      rect(ctx, c4, 40, 34, 10, 8);
      mountain(ctx, 90, 80, 70, 36, c1, c3);
      rect(ctx, c0, 0, 78, W, 12);
    },
    farm() {
      sky(ctx, c4, c3);
      rect(ctx, c4, 118, 16, 14, 14);
      hills(ctx, 58, 8, c1, rand, 10);
      rect(ctx, c0, 40, 52, 22, 18);
      rect(ctx, c2, 46, 46, 10, 8);
      rect(ctx, c1, 0, 70, W, 20);
    },
    dungeon() {
      sky(ctx, c0, c1);
      for (let y = 20; y < 80; y += 8) {
        for (let x = 0; x < W; x += 12) rect(ctx, (x + y) % 24 ? c1 : c0, x, y, 11, 7);
      }
      rect(ctx, c2, 20, 40, 4, 10);
      rect(ctx, c2, 136, 40, 4, 10);
      rect(ctx, c0, 0, 80, W, 10);
    },
    clouds() {
      sky(ctx, c4, c3);
      const puff = (x, y, s) => {
        rect(ctx, c4, x, y, s, 6);
        rect(ctx, c4, x + 4, y - 4, s - 4, 6);
      };
      puff(10, 28, 28); puff(60, 18, 36); puff(110, 32, 30);
      hills(ctx, 70, 6, c1, rand, 12);
    },
    cave() {
      sky(ctx, c0, c1);
      for (let x = 0; x < W; x += 6) rect(ctx, c1, x, 0, 4, 8 + Math.floor(rand() * 16));
      for (let x = 4; x < W; x += 8) rect(ctx, c0, x, H - 10 - Math.floor(rand() * 14), 5, 24);
      rect(ctx, c2, 78, 48, 4, 4);
    },
    aurora() {
      sky(ctx, c0, c1);
      for (let x = 0; x < W; x++) {
        ctx.fillStyle = hexLerp(c2, c3, Math.abs(Math.sin(x / 14)));
        ctx.fillRect(x, 12, 1, 22);
      }
      hills(ctx, 68, 8, c0, rand, 9);
      rect(ctx, c4, 0, 80, W, 10);
    },
    void() {
      sky(ctx, c0, c1);
      stars(ctx, 50, c2, rand);
      rect(ctx, c3, 60, 30, 40, 28);
      rect(ctx, c0, 70, 40, 20, 18);
    },
    ember() {
      sky(ctx, c0, c1);
      mountain(ctx, 20, 80, 120, 50, c1, c3);
      rect(ctx, c2, 0, 78, W, 12);
    },
    moss() {
      sky(ctx, c4, c1);
      for (let i = 0; i < 10; i++) tree(ctx, 6 + i * 16, 46, c0, c2);
      rect(ctx, c1, 0, 76, W, 14);
    },
    orchid() {
      sky(ctx, c0, c1);
      stars(ctx, 16, c2, rand);
      tree(ctx, 40, 48, c0, c3);
      tree(ctx, 100, 52, c0, c2);
      rect(ctx, c0, 0, 80, W, 10);
    },
    ink() {
      sky(ctx, c0, c1);
      for (let x = 0; x < W; x += 8) rect(ctx, c2, x, 20 + (x % 16), 6, 50);
      rect(ctx, c3, 0, 78, W, 12);
    },
    scroll() {
      sky(ctx, c3, c4);
      rect(ctx, c2, 20, 18, 120, 54);
      rect(ctx, c1, 28, 26, 104, 38);
      rect(ctx, c0, 0, 80, W, 10);
    },
  };

  const fn = scenes[id] || scenes.aurora;
  fn();
  return c.toDataURL("image/png");
}

export const BG_PRESETS = [
  { id: "forest", name: "Bosque" },
  { id: "space", name: "Espacio" },
  { id: "ocean", name: "Océano" },
  { id: "desert", name: "Desierto" },
  { id: "volcano", name: "Volcán" },
  { id: "tundra", name: "Tundra" },
  { id: "neon", name: "Neón" },
  { id: "sakura", name: "Sakura" },
  { id: "swamp", name: "Pantano" },
  { id: "arcade", name: "Arcade" },
  { id: "medieval", name: "Castillo" },
  { id: "abyss", name: "Abismo" },
  { id: "steam", name: "Steampunk" },
  { id: "farm", name: "Pradera" },
  { id: "dungeon", name: "Mazmorra" },
  { id: "clouds", name: "Nubes" },
  { id: "cave", name: "Cueva" },
  { id: "aurora", name: "Aurora" },
  { id: "void", name: "Vacío" },
  { id: "ember", name: "Brasa" },
  { id: "moss", name: "Musgo" },
  { id: "orchid", name: "Orquídea" },
  { id: "ink", name: "Tinta" },
  { id: "scroll", name: "Pergamino" },
];

const cache = {};

export function themeBackgroundUrl(id) {
  const key = id && BG_PRESETS.some((b) => b.id === id) ? id : "aurora";
  if (!cache[key]) cache[key] = paintScene(key);
  return cache[key];
}

export function resolveThemeBackground(config) {
  if (!config) return "";
  if (config.bg_source === "none") return "";
  if (config.bg_image) return config.bg_image;
  if (config.bg_preset) return themeBackgroundUrl(config.bg_preset);
  if (config.skin) return themeBackgroundUrl(config.skin);
  return themeBackgroundUrl("aurora");
}

export function pixelateBackgroundFile(file, { w = 160, h = 90 } = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Imagen inválida"));
      img.onload = () => {
        const small = document.createElement("canvas");
        small.width = w;
        small.height = h;
        const sctx = small.getContext("2d");
        sctx.imageSmoothingEnabled = false;
        const scale = Math.max(w / img.width, h / img.height);
        const dw = img.width * scale;
        const dh = img.height * scale;
        sctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
        const out = document.createElement("canvas");
        out.width = w * 3;
        out.height = h * 3;
        const octx = out.getContext("2d");
        octx.imageSmoothingEnabled = false;
        octx.drawImage(small, 0, 0, out.width, out.height);
        resolve(out.toDataURL("image/png"));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
